import axios from '@/plugins/axios';

class PatientApi {
  static fetchPatients(
    page = 1,
    limit = 10,
    patientType,
    geneticStatus,
    eyesPosition,
    sex,
    type,
    minAge,
    maxAge,
    minVisualRange,
    maxVisualRange,
    demand,
    treatmentHistory,
    mobile,
    nickName,
    nickId,
  ) {
    return axios({
      url: '/api/stat/patient/page',
      data: {
        page,
        limit,
        patient_type: patientType,
        is_genetic: geneticStatus,
        eye_position: eyesPosition,
        sex,
        type,
        min_age: minAge,
        max_age: maxAge,
        min_naked_eye_vision: minVisualRange,
        max_naked_eye_vision: maxVisualRange,
        self_describe: demand,
        cure_history: treatmentHistory,
        nick_name: nickName,
        mobile,
        nick_id: nickId,
      },
      method: 'post',
      headers: {
        meta: {
          skipSuccess: true,
          desc: '查询患者信息列表',
        },
      },
    });
  }

  static fetchPatientDemand() {
    return axios({
      url: '/api/sys/patient/info',
      method: 'get',
      headers: {
        meta: {
          skipSuccess: true,
          desc: '获取患者诉求选项',
        },
      },
    });
  }

  static export(data) {
    return axios({
      url: '/api/stat/patient/export',
      method: 'post',
      data,
      headers: {
        meta: {
          skipSuccess: true,
          desc: '导出',
        },
      },
    });
  }

  static fetchStatPatientLog(
    customerId,
  ) {
    return axios({
      url: '/api/stat/patient/log',
      data: {
        customer_id: customerId,
      },
      method: 'post',
      headers: {
        meta: {
          skipSuccess: true,
          desc: '查询患者眼健康档案历史',
        },
      },
    });
  }
}

export default PatientApi;
